import type { MigrationStrategies } from "rxdb";

export const IMAGING_INSTANCE_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => {
    return oldDoc;
  },
  2: (_) => null,
  3: (_) => null,
  // v4: PNE-212 — add dicomPreset and physicalDeltaMm, passthrough
  4: (oldDoc) => oldDoc,
  // v5: PNE-213 — patientId made nullable, accession-only instances have no patient
  5: (oldDoc) => oldDoc,
  // v6: PNE-213 — remove patientId from indexes (RxDB cannot index nullable fields)
  6: (oldDoc) => oldDoc,
  // v7: PNE-221 — add optional dicomStudyId for study-scoped queries on no-accession encounters
  7: (oldDoc) => ({ ...oldDoc, dicomStudyId: null }),
  // v8: PNE-427 — add DICOM device identity, default null for existing docs
  8: (oldDoc) => ({
    ...oldDoc,
    deviceManufacturer: null,
    deviceModelName: null,
  }),
  9: (oldDoc) => ({
    ...oldDoc,
    numberOfFrames: null,
    frameRate: null,
    cineStatus: null,
    cineS3Key: null,
    cineDurationMs: null,
    cineSizeBytes: null,
  }),
  // v10: patientId renamed to elephantPatientId (PNE-598), same value.
  10: ({ patientId, ...rest }) => ({
    ...rest,
    elephantPatientId: patientId ?? null,
  }),
} satisfies MigrationStrategies;
